import styles from 'styles/components/bannerWrapper.module.scss';

const BannerWrapper = ({ children }) => {
  return <div className={styles.bannerWrapper}>{children}</div>;
};

export default BannerWrapper;